export function formatNumber(value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ',')
}
export default {
  formatNumber
}



// WEBPACK FOOTER //
// ./src/utils/utils.js